import React from "react";
import hoistNonReactStatics from "hoist-non-react-statics";
import { useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import { gql } from "@apollo/client";

import {
  Box,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Tooltip,
  Typography,
  IconButton,
} from "@mui/material";
import {
  Lock as LockedIcon,
  Delete as DeleteIcon,
  Menu as MenuIcon,
} from "mdi-material-ui";

import DeleteOrderState from "./DeleteOrderState";

function OrderStatesListItem(
  { orderState, index, handleProps, ...props },
  ref
) {
  const match = useRouteMatch();

  return (
    <ListItem
      ref={ref}
      dense
      divider
      button
      component={Link}
      to={`${match.url}/${orderState.id}`}
      {...props}
    >
      <ListItemIcon {...handleProps}>
        <MenuIcon />
      </ListItemIcon>

      <ListItemText
        sx={{ opacity: orderState.deleted && 0.5 }}
        primary={
          <Box
            // color="primary"
            color={(t) => t.palette.primary.main}
          >
            {orderState.label || "Aucun nom"}

            <Box
              component="span"
              ml="0.5ch"
              fontSize="small"
              color="text.secondary"
            >
              ({orderState.name}
              {orderState.locked && (
                <LockedIcon
                  style={{
                    marginLeft: "0.5ch",
                    fontSize: "1em",
                    transform: "translateY(15%)",
                  }}
                />
              )}
              )
            </Box>
          </Box>
        }
        secondary={
          <>
            <Typography>{orderState.clientState}</Typography>
            <Typography>
              <span role="img" aria-label="FR">
                🇫🇷
              </span>{" "}
              {orderState.clientLabel?.fr}
            </Typography>
            <Typography>
              <span role="img" aria-label="EN">
                🇬🇧
              </span>{" "}
              {orderState.clientLabel?.en}
            </Typography>
          </>
        }
        secondaryTypographyProps={{ component: "div" }}
      />

      <ListItemSecondaryAction>
        <DeleteOrderState orderState={orderState}>
          {({ open }) =>
            !orderState.deleted && (
              <Tooltip
                placement="left"
                title={orderState.locked ? "Verrouillé" : "Supprimer"}
              >
                <div>
                  <IconButton
                    disabled={orderState.locked}
                    onClick={open}
                    size="large"
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </Tooltip>
            )
          }
        </DeleteOrderState>
      </ListItemSecondaryAction>
    </ListItem>
  );
}

OrderStatesListItem.fragments = {
  orderState: gql`
    fragment OrderStatesListItem_OrderState on OrderState {
      id
      deleted
      locked
      name
      label
      clientState
      clientLabel {
        fr
        en
      }
    }
  `,
};

export default hoistNonReactStatics(
  React.forwardRef(OrderStatesListItem),
  OrderStatesListItem
);
